import React from "react";

import PeopleIcon from "../../../assets/icons/front-pages/people.svg";
import CursorIcon from "../../../assets/icons/front-pages/cursor.svg";
import MessagesIcon from "../../../assets/icons/front-pages/messages.svg";
import { getStyles } from "../../../assets/js/utils/functions";
import AnimatedHeaderText from "../commons/animated-header-text";

const CatlogPromise = () => {
  return (
    <section className="body-padding body-y-padding">
      <div className="container">
        <AnimatedHeaderText
          className="mb-10 sm:mb-12.5 lg:mb-15"
          series={[
            ["Here's", "what", "we"],
            ["promise", "you!"],
          ]}
        />
        <div className="grid grid-cols-1 md:grid-cols-3 mt-8 sm:mt-12.5 md:mt-16 lg:mt-20 gap-5 md:gap-6 lg:gap-7.5 hide-for-observer">
          {promises.map((p, index) => (
            <article
              className={`p-8 sm:p-11.25 md:px-8 md:py-10 lg:px-10 lg:py-12.5 rounded-15 sm:rounded-20 lg:rounded-[25px] anim-word-up ${p.color}`}
              key={index}
              style={getStyles({ "--delay": `${index * 0.25}s`, "--from": "15%", "--duration": "1s" })}
            >
              <figure className="h-15 w-15 sm:h-17.5 sm:w-17.5 lg:h-20 lg:w-20 bg-white rounded-full flex items-center justify-center">
                <div className="w-1/2">
                  <p.icon />
                </div>
              </figure>
              <p className="font-display text-black font-bold text-lg sm:text-xl lg:text-2lg xl:text-2xl mt-3.75 sm:mt-5">
                {p.text}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

const promises = [
  {
    text: "We will be your business partner, you can always count on us",
    color: "text-accent-yellow-500 bg-accent-yellow-pastel",
    icon: PeopleIcon,
  },
  {
    text: "Our platform will always be easy to use, for you and your customers",
    color: "text-accent-red-500 bg-accent-red-pastel",
    icon: CursorIcon,
  },
  {
    text: "You will always get support from us, whenever and wherever you need it",
    color: "text-accent-orange-500 bg-accent-orange-pastel",
    icon: MessagesIcon,
  },
];

export default CatlogPromise;
